function If({ condition, children }) {
  return condition ? <>{children}</> : <></>;
}

export { If };
